import type { GetAllInput } from "@types_def/common/filter.types";
import type { Delivery } from "@types_def/models/delivery.types";

import { sendRequest } from "../../clients/axios";

export function downloadDeliveries(filters: GetAllInput<Delivery, "id">) {
  sendRequest<GetAllInput<Delivery, "id">, { data: Iterable<number> }>(
    "post",
    "delivery/export-deliveries-excel-admins",
    filters
  )
    .then((res) => {
      if (res.status === 201) {
        const bufferParsed = new Uint8Array(res.data.data);
        const blob = new Blob([bufferParsed], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        return URL.createObjectURL(blob);
      }
    })
    .then((fileURL) => {
      const windowReference = window.open("", "_self");
      // @ts-expect-error
      if (windowReference) {
        windowReference.location = fileURL;
      }
    });
}
